import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation, useQueryClient } from 'react-query';

import { cashbackConstants } from '..';

export const useCashbackConfigDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (id: number) => {
      const res = await $api.delete(
        stringifyUrl({
          url: '/v1/cashback/config',
          query: {
            configId: id
          }
        })
      );

      return res.data;
    },
    {
      onSuccess: res => {
        showMessage(res.message, res.accept);
        qc.invalidateQueries([cashbackConstants.queryKeys.CASHBACK_CONFIG_ALL]);
        qc.invalidateQueries([cashbackConstants.queryKeys.CASHBACK_ACTIVE]);
      }
    }
  );
};
